import request from '../../../../../services/axios';

export interface ICreditPayAvailableOptions {
  has_credit: boolean;
  has_cashback: boolean;
  has_bnpl: boolean;
}

export const getCreditPayAvailableOptions = async () => {
  const {data}: {data: ICreditPayAvailableOptions} = await request.get(
    `/api/v2/payment/credit-availability`,
  );

  return data;
};
